import { DialogContent, DialogOverlay } from "@reach/dialog";
import "@reach/dialog/styles.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<Props> = ({ isOpen, onClose, children }) => (
  <DialogOverlay isOpen={isOpen} onDismiss={onClose} style={{ zIndex: 30 }}>
    <DialogContent
      aria-label="modal"
      style={{
        width: "100%",
        padding: 0,
        background: "transparent",
      }}
    >
      {children}
    </DialogContent>
  </DialogOverlay>
);

export default Modal;
